import { callCallableNativeSafe } from './callableNativeSafe';

export function approveEventBooking(businessId, bookingId) {
  return callCallableNativeSafe({
    functionName: 'approveEventBookingV1', data: { businessId, bookingId },
    requireAuth: true, timeoutMs: 60000,
  });
}
